export const GOOGLE_MAP_HEIGHT = 350;
export const GOOGLE_MAP_MARKER_SIZE = 16;
export const GOOGLE_MAP_ZOOM = 10;
export const GOOGLE_MAP_MARKER_INFO_OFFSET = 14;
export const USA_CENTER_COORDINATES = {
  lat: 44.5,
  lng: -89.5,
};

export const KM_TO_MILES = 0.621371;
